/*
================================================================ 
         Copyright (c) 2018-2021 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import { connect } from "react-redux";
import React, { Component, useRef } from "react";

import Input from "../../../component/inputpm";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import { withTranslation } from "react-i18next";

import Loader from "../../../component/loader";
import Table from "@mui/material/Table";
import Button from "../../../component/button";
import TableRow from "@mui/material/TableRow";
import Collapse from "@mui/material/Collapse";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import CardPaymentIcon from "react-payment-icons";
import IconButton from "@mui/material/IconButton";

import BusApiCall from "../../../helper/axios.js";
import constants from "../../../helper/constants";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import actionTypes from "../../../store/actions";
import Delete from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import classes from "./customer.module.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import PaymentMethodDialog from "./paymentMethodDialog";
import { CardContent, TableHead } from "@mui/material";
import Card from "@mui/material/Card";
import stateCode from "../../../helper/stateCode";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
class PaymentDetails extends Component {
  state = {
    years: [],
    cardLogoId: "",
    isPrimary: false,
    bankPaymentMethodOption: true,
    cardPaymentMethodOption: true,
    months: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ],

    displayCredtCardForm: false,
    displayEftAccountForm: false,

    //send payment details for credit card
    expireMonth: "",
    expireYear: "",
    creditCard: {},
    cardType: "",
    cardNumber: "",
    expireDate: "",
    lastNameOnCard: "",
    firstNameOnCard: "",
    openCardDetails: false,

    //send payment details for bank accouny
    openBankDetails: false,
    bankName: "",
    accountType: "",
    routingNumber: "",
    accountNumber: "",
    nameOnAccount: "",
    eftAccount: {},

    paymentInstrumentsMap: [],
    creditCardListpaymentMethodList: [],
    creditCardList: [],
    eftAccountList: [],
    loading: false,
    paymentMethodId: "",

    //dialogs
    dialogTitle: "",
    paymentMethodType: "",
    billingContactMechId: "",
    addPaymentMethodDialog: false,
    editPaymentMethodDialog: false,

    //payment detail field
    attention: "",
    phone: "",
    street1: "",
    street2: "",
    city: "",
    state: "",
    zip: "",
    country: this.props.defaultCountry,

    dataError: {
      message: "",
      show: false,
    },
    isFirstPaymentMethod: false,
  };
  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  componentDidMount() {
    this.setState(
      {
        loading: true,
        creditCardList: this.props.creditCardList,
        eftAccountList: this.props.eftAccountList,
        paymentMethodList: this.props.paymentMethodList,
        billingAddressList: this.props.billingAddressList,
      },
      () => {
        let paymetMethodsLength = 0;
        if (this.state.creditCardList && this.state.creditCardList.length > 0) {
          paymetMethodsLength += this.state.creditCardList.length;
          this.state.creditCardList.map(
            (card, i) => {
              let date = card.expireDate.split("/");
              card.expireYear = date[1];
              card.expireMonth = date[0];
              card.openCardDetails = false;
            },
            () => {
              this.setState({ loading: false });
            },
          );
        }
        if (this.state.eftAccountList && this.state.eftAccountList.length > 0) {
          paymetMethodsLength += this.state.eftAccountList.length;
          this.state.eftAccountList.map(
            (eft, i) => {
              eft.openBankDetails = false;
            },
            () => {
              this.setState({ loading: false });
            },
          );
        }
        this.setState({
          isFirstPaymentMethod: paymetMethodsLength > 0 ? false : true,
        });
      },
    );
    var date = new Date();
    let currentYear = date.getFullYear();
    let years = [];
    years.push(currentYear);
    for (var i = 0; i < 20; i++) {
      currentYear++;
      years.push(currentYear);
      if (i == 19) {
        this.setState(
          {
            years: years,
          },
          () => {
            this.setState({ loading: false });
          },
        );
      }
    }
  }

  //add a paymnet method dialog
  addPaymentMethodDialogBox = (paymentMethod) => {
    //open the dialog : addPaymentMethodDialog
    this.setState({
      addPaymentMethodDialog: true,
      paymentMethodType: paymentMethod,
    });

    if (paymentMethod === "CREDIT_CARD") {
      this.setState({ dialogTitle: this.props.t("ADD_A_CREDIT_CARD") });
    } else if (paymentMethod === "EFT_ACCOUNT") {
      this.setState({ dialogTitle: this.props.t("ADD_A_BANK_ACCOUNT") });
    }
  };

  //handle a dialog
  handleDialog = (action) => {
    this.setState({
      addPaymentMethodDialog: action,
      editPaymentMethodDialog: action,
    });
  };

  onChange = (e) => {
    //get the cart type when paymnet method if credit card
    //and the card number is filled
    if (e.target.name === "cardNumber") {
      //American Express
      if (e.target.value[0] === "3") {
        this.setState({
          cardLogoId: "amex",
          cardType: "CCT_AMERICANEXPRESS",
        });
      }
      //visa
      else if (e.target.value[0] === "4") {
        this.setState({
          cardLogoId: "visa",
          cardType: "CCT_VISA",
        });
      }
      //MasterCard
      else if (e.target.value[0] === "5" || e.target.value[0] === "2") {
        this.setState({
          cardLogoId: "mastercard",
          cardType: "CCT_MASTERCARD",
        });
      }
      //others : add a valid message
      else {
        this.setState({
          cardLogoId: "",
        });
      }
    }
    //set the values to state
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {},
    );
  };

  setOpen = (value, paymentType, index) => {
    if (paymentType === "CREDIT_CARD") {
      let creditCardList = [...this.state.creditCardList];
      creditCardList[index].openCardDetails = value;
      this.setState({
        creditCardList: creditCardList,
      });
    } else if (paymentType === "EFT_ACCOUNT") {
      let eftAccountList = [...this.state.eftAccountList];
      eftAccountList[index].openBankDetails = value;
      this.setState({
        eftAccountList: eftAccountList,
      });
    }
  };

  setPaymentOption = (paymentType, value) => {
    this.setState(
      {
        [paymentType]: value,
      },
      () => {},
    );
  };

  setPrimaryMethod = (e) => {
    this.setState(
      {
        isPrimary: e.target.checked,
      },
      () => {},
    );
  };

  setMethodAsPrimary = (e, index, paymentType) => {
    this.setState({
      loading: true,
    });
    let contactMechId =
      paymentType === "CREDIT_CARD"
        ? this.state.creditCardList[index].paymentMethodId
        : this.state.eftAccountList[index].paymentMethodId;
    let data = {
      type: "payment",
      isPrimary: true,
      contactMechId: contactMechId,
    };

    this.setState(
      {
        isPrimary: e.target.checked,
      },
      () => {
        BusApiCall(
          "POST",
          `${constants.busV4Url}/customers/${this.props.partyId}/primary`,
          data,
        )
          .then((res) => {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_PAYMENT_METHOD_UPDATED"),
              true,
            );
            for (var i = 0; i < this.state.creditCardList.length; i++) {
              if (i === index) {
                if (paymentType === "CREDIT_CARD") {
                  this.state.creditCardList[i].primary = true;
                } else {
                  this.state.creditCardList[i].primary = false;
                }
              } else {
                this.state.creditCardList[i].primary = false;
              }
            }

            for (var i = 0; i < this.state.eftAccountList.length; i++) {
              if (i === index) {
                if (paymentType === "EFT_ACCOUNT") {
                  this.state.eftAccountList[i].primary = true;
                } else {
                  this.state.eftAccountList[i].primary = false;
                }
              } else {
                this.state.eftAccountList[i].primary = false;
              }
            }

            this.setState({
              loading: false,
            });
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      },
    );
  };

  displayCredtCardForm = (value) => {
    this.setState(
      {
        expireMonth: "",
        expireYear: "",
        cardType: "",
        cardNumber: "",
        expireDate: "",
        lastNameOnCard: "",
        firstNameOnCard: "",
        isPrimary: false,
        displayCredtCardForm: value,
      },
      () => {},
    );
  };

  displayEftAccountForm = (value) => {
    this.setState(
      {
        bankName: "",
        accountType: "",
        routingNumber: "",
        accountNumber: "",
        nameOnAccount: "",
        displayEftAccountForm: value,
      },
      () => {},
    );
  };

  createPaymentMethodPayload = (data) => {
    if (data) {
      this.setState({ loading: true });
      let payment = [];
      let paymentData = {
        contact: {
          firstName: "",
          lastName: "",
          partyId: "",
          officePhone: "",
          mobilePhone: "",
          email: "",
          emailMechId: "",
          mobilePhoneMechId: "",
          officePhoneMechId: "",
          billingCloseDay: "",
        },
        billing: {
          attention: "",
          phone: "",
          street1: "",
          street2: "",
          city: "",
          state: "",
          zip: "",
          country: "",
        },
        shipping: {
          attention: "",
          phone: "",
          street1: "",
          street2: "",
          city: "",
          state: "",
          zip: "",
          country: "",
        },
        banDetails: {
          accountName: "",
          ban: "",
        },
      };
      //when sales channel creates the profile for the customer
      if (
        this.props.providerType === "SALES_CHNL_PROVIDER" &&
        (this.props.loggedInUserType != "ECOMMERCE_CUSTOMER" ||
          this.props.loggedInUserType != "ECOMMERCE_ADMIN")
      ) {
        paymentData.contact.partyId = this.props.customerDetails.id;
        paymentData.banDetails.ban = this.props.customerDetails.ban;
        paymentData.banDetails.accountName =
          this.props.customerDetails.accountName;
      }
      let t = this.props.t;
      if (this.state.paymentMethodType === "CREDIT_CARD") {
        var date = new Date();
        let currentYear = date.getFullYear();
        let currentMonth = date.getMonth();
        let dataError = {
          message: "",
          show: false,
        };
        if (!data.cardNumber) {
          dataError = {
            message: t("CARD_NUMBER_IS_REQUIRED"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else if (!data.firstNameOnCard) {
          dataError = {
            message: t("FIRST_NAME_ON_CARD_IS_REQUIRED"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else if (!data.expireMonth) {
          dataError = {
            message: t("CARD_EXPIRY_MONTH_IS_REQUIRED"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else if (!data.expireYear) {
          dataError = {
            message: t("CARD_EXPIRY_YEAR_IS_REQUIRED"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else if (
          +data.expireYear === currentYear &&
          +data.expireMonth < currentMonth + 1
        ) {
          dataError = {
            message: t("CARD_EXPIRY_MONTH_IS_NOT_VALID"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else if (!data.billingAttention) {
          dataError = {
            message: t("BILLING_ADDRESS_IS_REQUIRED"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else {
          dataError = {
            message: "",
            show: false,
          };
          this.setState({
            dataError,
          });
          let creditCard = {
            cardType: data.cardType,
            isPrimary:
              this.props.screen === "invoicePayment" ? false : data.isPrimary,
            cardNumber: data.cardNumber,
            expireYear: data.expireYear,
            expireMonth: data.expireMonth,

            zip: data.billingZip,
            city: data.billingCity,
            state: data.billingState,
            street1: data.billingStreet1,
            street2: data.billingStreet2,
            country: data.billingCountry,
            attention: data.billingAttention,

            billingContactMechId: data.billingContactMechId,
            expireDate: data.expireMonth + "/" + data.expireYear,
            nameOnCard: data.firstNameOnCard + " " + data.lastNameOnCard,
          };
          this.setState(
            {
              creditCard: creditCard,
              cardType: data.cardType,
              isPrimary:
                this.props.screen === "invoicePayment" ? false : data.isPrimary,
              cardNumber: data.cardNumber,
              expireYear: data.expireYear,
              expireMonth: data.expireMonth,
              firstNameOnCard: data.firstNameOnCard,
              lastNameOnCard: data.lastNameOnCard,

              zip: data.billingZip,
              city: data.billingCity,
              state: data.billingState,
              street1: data.billingStreet1,
              street2: data.billingStreet2,
              country: data.billingCountry,
              attention: data.billingAttention,

              billingContactMechId: data.billingContactMechId,
            },
            () => {
              payment = {
                creditCard: creditCard,
              };
              this.setState(
                {
                  paymentInstrumentsMap: payment,
                },
                () => {
                  //adding extra data as the API needs it
                  paymentData.paymentInstrumentsMap =
                    this.state.paymentInstrumentsMap;
                  this.createPaymentMethod(
                    paymentData,
                    this.state.paymentMethodType,
                  );
                },
              );
            },
          );
        }
      } else if (this.state.paymentMethodType === "EFT_ACCOUNT") {
        let dataError = {
          message: "",
          show: false,
        };
        if (!data.bankName) {
          dataError = {
            message: t("BANK_NAME_IS_REQUIRED"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else if (!data.nameOnAccount) {
          dataError = {
            message: t("NAME_ON_ACCOUNT_IS_REQUIRED"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else if (!data.routingNumber) {
          dataError = {
            message: t("ROUTING_NUMBER_IS_REQUIRED"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else if (data.routingNumber.length !== 9) {
          dataError = {
            message: t("INVALID_ROUTING_NUMBER"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else if (!data.accountNumber) {
          dataError = {
            message: t("ACCOUNT_NUMBER_IS_REQUIRED"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else if (data.accountNumber.length > 17) {
          dataError = {
            message: t("INVALID_ACCOUNT_NUMBER"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else if (!data.billingAttention) {
          dataError = {
            message: t("BILLING_ADDRESS_IS_REQUIRED"),
            show: true,
          };
          this.setState({
            dataError,
          });
        } else {
          dataError = {
            message: "",
            show: false,
          };
          this.setState({
            dataError,
          });
          let eftAccount = {
            bankName: data.bankName,
            accountType: data.accountType,
            routingNumber: data.routingNumber,
            accountNumber: data.accountNumber,
            nameOnAccount: data.nameOnAccount,

            zip: data.billingZip,
            city: data.billingCity,
            state: data.billingState,
            street1: data.billingStreet1,
            street2: data.billingStreet2,
            country: data.billingCountry,
            attention: data.billingAttention,

            billingContactMechId: data.billingContactMechId,
            isPrimary:
              this.props.screen === "invoicePayment" ? false : data.isPrimary,
          };
          this.setState(
            {
              eftAccount: eftAccount,
              bankName: data.bankName,
              accountType: data.accountType,
              routingNumber: data.routingNumber,
              accountNumber: data.accountNumber,
              nameOnAccount: data.nameOnAccount,
              zip: data.billingZip,
              city: data.billingCity,
              state: data.billingState,
              street1: data.billingStreet1,
              street2: data.billingStreet2,
              country: data.billingCountry,
              attention: data.billingAttention,
              billingContactMechId: data.billingContactMechId,
              isPrimary:
                this.props.screen === "invoicePayment" ? false : data.isPrimary,
            },
            () => {
              payment = {
                eftAccount: eftAccount,
              };
              this.setState(
                {
                  paymentInstrumentsMap: payment,
                },
                () => {
                  //adding extra data as the API needs it
                  paymentData.paymentInstrumentsMap =
                    this.state.paymentInstrumentsMap;
                  this.createPaymentMethod(
                    paymentData,
                    this.state.paymentMethodType,
                  );
                },
              );
            },
          );
        }
      }
    } else {
      let dataError = {
        message: "",
        show: false,
      };
      this.setState(
        {
          addPaymentMethodDialog: false,
          dataError,
        },
        () => {},
      );
    }
    this.setState({ loading: false });
  };

  createPaymentMethod = (paymentData, paymentType) => {
    this.setState({ loading: true });
    let eftAccountList = [...this.state.eftAccountList];
    let creditCardList = [...this.state.creditCardList];
    BusApiCall("POST", `${constants.busInternalUrl}/customers`, paymentData)
      .then((res) => {
        if (res.data.responseMessage === "success") {
          if (this.props.screen === "invoicePayment") {
            let paymentData = JSON.parse(res.data.customer.paymentMethod);
            this.setState({ loading: true });
            // TODO: Add api here
            BusApiCall(
              "POST",
              `${constants.busV4Url}/invoice/${this.props.invoiceId}/paymentMethod/${paymentData.paymentMethodId}`,
              {},
            )
              .then((res) => {
                this.props.setErrorMessage(
                  this.props.t("PAYMENT_INITIATED_SUCCESSFULLY"),
                  true,
                );
                this.setState({
                  loading: false,
                });
              })
              .catch((err) => {
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  this.props.setErrorMessage(err.response.data.message, false);
                } else {
                  this.props.setErrorMessage(
                    this.props.t("DEFAULT_ERROR_MESSAGE"),
                    false,
                  );
                }
                this.setState({ loading: false });
              });

            this.props.closePaymentDialog(false);
          }
          if (this.state.isPrimary) {
            for (var i = 0; i < this.state.eftAccountList.length; i++) {
              this.state.eftAccountList[i].primary = false;
            }
            for (var i = 0; i < this.state.creditCardList.length; i++) {
              this.state.creditCardList[i].primary = false;
            }
          }
          let paymentData = JSON.parse(res.data.customer.paymentMethod);
          let paymentMethodId = paymentData.paymentMethodId;
          if (paymentType === "EFT_ACCOUNT") {
            let eft = {
              bankName: this.state.bankName,
              accountType: this.state.accountType,
              routingNumber: this.state.routingNumber,
              accountNumber: this.state.accountNumber,
              nameOnAccount: this.state.nameOnAccount,
              zip: this.state.zip,
              state: this.state.state,
              city: this.state.city,
              street1: this.state.street1,
              street2: this.state.street2,
              attention: this.state.attention,
              country: this.state.country,
              primary: this.state.isPrimary,
              paymentMethodId,
            };
            eftAccountList.push({ ...eft });
            this.setState(
              {
                eftAccountList: eftAccountList,
              },
              () => {
                this.props.setErrorMessage(
                  this.props.t("PAYMENT_METHOD_ADDED_SUCCESSFULLY"),
                  true,
                );
                this.setState({
                  loading: false,
                  displayEftAccountForm: false,
                  addPaymentMethodDialog: false,
                });
              },
            );
          } else if (paymentType === "CREDIT_CARD") {
            let card = {
              cardType: this.state.cardType,
              primary: this.state.isPrimary,
              cardNumber: this.state.cardNumber,
              firstNameOnCard: this.state.firstNameOnCard,
              lastNameOnCard: this.state.lastNameOnCard,
              expireMonth: this.state.expireMonth,
              expireYear: this.state.expireYear,
              expireDate: this.state.expireMonth + "/" + this.state.expireYear,
              attention: this.state.attention,
              zip: this.state.zip,
              state: this.state.state,
              city: this.state.city,
              street1: this.state.street1,
              street2: this.state.street2,
              country: this.state.country,
              paymentMethodId,
            };
            creditCardList.push({ ...card });
            this.setState(
              {
                creditCardList: creditCardList,
              },
              () => {
                this.props.setErrorMessage(
                  this.props.t("PAYMENT_METHOD_ADDED_SUCCESSFULLY"),
                  true,
                );
                this.setState({ loading: false, displayCredtCardForm: false });
              },
            );
          }
        }
        this.setState({
          loading: false,
          displayCredtCardForm: false,
          addPaymentMethodDialog: false,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
          displayCredtCardForm: false,
          displayEftAccountForm: false,
          addPaymentMethodDialog: false,
        });
      });
  };

  updateChange = (e, paymentType) => {
    let value = "";
    if (e.target.name === "primary") {
      value = e.target.checked;
    } else {
      value = e.target.value;
    }
    if (paymentType === "CREDIT_CARD") {
      let creditCardList = [...this.state.creditCardList];
      //creditCardList[index][e.target.name] = value
      this.setState({
        [e.target.name]: e.target.value,
        //creditCardList : creditCardList,
      });
    } else if (paymentType === "EFT_ACCOUNT") {
      let eftAccountList = [...this.state.eftAccountList];
      //eftAccountList[index][e.target.name] = value
      this.setState({
        [e.target.name]: e.target.value,
        //eftAccountList : eftAccountList,
      });
    }
  };

  //updateCustomerPaymentPayload = (method, index, paymentType) => {
  updateCustomerPaymentPayload = (paymentType) => {
    let payment = [];
    this.setState({ loading: true });
    let paymentData = {
      contact: {
        firstName: "",
        lastName: "",
        partyId: "",
        officePhone: "",
        mobilePhone: "",
        email: "",
        emailMechId: "",
        mobilePhoneMechId: "",
        officePhoneMechId: "",
        billingCloseDay: "",
      },
      billing: {
        attention: "",
        phone: "",
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      },
      shipping: {
        attention: "",
        phone: "",
        street1: "",
        street2: "",
        city: "",
        state: "",
        zip: "",
        country: "",
      },
      banDetails: {
        accountName: "",
        ban: "",
      },
    };
    //when sales channel creates the profile for the customer
    if (
      this.props.providerType === "SALES_CHNL_PROVIDER" &&
      (this.props.loggedInUserType != "ECOMMERCE_CUSTOMER" ||
        this.props.loggedInUserType != "ECOMMERCE_ADMIN")
    ) {
      paymentData.contact.partyId = this.props.customerDetails.id;
      paymentData.banDetails.ban = this.props.customerDetails.ban;
      paymentData.banDetails.accountName =
        this.props.customerDetails.accountName;
    }
    var date = new Date();
    let currentYear = date.getFullYear();
    let currentMonth = date.getMonth();
    if (paymentType === "CREDIT_CARD") {
      let creditCard = {
        cardType: this.state.cardType,
        isPrimary: this.state.isPrimary,
        cardNumber: this.state.cardNumber,
        expireYear: this.state.expireYear,
        expireMonth: this.state.expireMonth,
        expireDate: this.state.expireMonth + "/" + this.state.expireYear,
        nameOnCard:
          this.state.firstNameOnCard + " " + this.state.lastNameOnCard,
        paymentMethodId: this.state.paymentMethodId,
        isPrimary: this.state.isPrimary,
        lastNameOnCard: this.state.lastNameOnCard,
        firstNameOnCard: this.state.firstNameOnCard,

        attention: this.state.attention,
        street1: this.state.street1,
        street2: this.state.street2,
        city: this.state.city,
        state: this.state.state,
        zip: this.state.zip,
        country: this.state.country,
        phone: this.state.phone,
      };
      if (!this.state.firstNameOnCard || !this.state.lastNameOnCard) {
        this.setState({ loading: false });
        this.props.setErrorMessage(
          this.props.t("FIRST_AND_LAST_NAME_IS_REQUIRED"),
          false,
        );
        return;
      }
      if (
        +this.state.expireYear === currentYear &&
        +this.state.expireMonth < currentMonth + 1
      ) {
        this.setState({ loading: false });
        this.props.setErrorMessage(
          this.props.t("CARD_EXPIRY_MONTH_IS_NOT_VALID"),
          false,
        );
        return;
      }

      this.setState(
        {
          creditCard: creditCard,
        },
        () => {
          payment = {
            creditCard: creditCard,
          };
          this.setState(
            {
              paymentInstrumentsMap: payment,
            },
            () => {
              //adding extra data as the API needs it
              paymentData.paymentInstrumentsMap =
                this.state.paymentInstrumentsMap;
              //this.updateCustomerPayment(paymentData, paymentType, index, method)
              this.updateCustomerPayment(paymentData, paymentType);
            },
          );
        },
      );
    } else if (paymentType === "EFT_ACCOUNT") {
      let eftAccount = {
        bankName: this.state.bankName,
        accountType: this.state.accountType,
        routingNumber: this.state.routingNumber,
        accountNumber: this.state.accountNumber,
        nameOnAccount: this.state.nameOnAccount,
        paymentMethodId: this.state.paymentMethodId,
        isPrimary: this.state.isPrimary,

        attention: this.state.attention,
        street1: this.state.street1,
        street2: this.state.street2,
        city: this.state.city,
        state: this.state.state,
        zip: this.state.zip,
        country: this.state.country,
        phone: this.state.phone,
      };
      this.setState(
        {
          eftAccount: eftAccount,
        },
        () => {
          payment = {
            eftAccount: eftAccount,
          };
          this.setState(
            {
              paymentInstrumentsMap: payment,
            },
            () => {
              //adding extra data as the API needs it
              paymentData.paymentInstrumentsMap =
                this.state.paymentInstrumentsMap;
              //this.updateCustomerPayment(paymentData, paymentType, index, method)
              this.updateCustomerPayment(paymentData, paymentType);
            },
          );
        },
      );
    }
  };

  updateCustomerPayment = (paymentData, paymentType) => {
    let eftAccountList = [...this.state.eftAccountList];
    let creditCardList = [...this.state.creditCardList];
    BusApiCall("POST", `${constants.busInternalUrl}/customers`, paymentData)
      .then((res) => {
        if (res.data.responseMessage === "success") {
          if (paymentType === "CREDIT_CARD") {
            let creditCard = this.state.creditCard;
            let index = creditCardList
              .map((e) => e.paymentMethodId)
              .indexOf(this.state.paymentMethodId);
            creditCardList.splice(index, 1, creditCard);
            this.setState(
              {
                creditCardList: creditCardList,
              },
              () => {
                this.setState({
                  editPaymentMethodDialog: false,
                  loading: false,
                });
                this.props.setErrorMessage(
                  this.props.t("PAYMENT_METHOD_UPDATED_SUCCESSFULLY"),
                  true,
                );
              },
            );
          } else if (paymentType === "EFT_ACCOUNT") {
            this.setState(
              {
                eftAccountList: eftAccountList,
              },
              () => {
                this.setState({
                  editPaymentMethodDialog: false,
                  loading: false,
                });
                this.props.setErrorMessage(
                  this.props.t("PAYMENT_METHOD_UPDATED_SUCCESSFULLY"),
                  true,
                );
              },
            );
          }
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  removePaymentMethod = (method, index, paymentType) => {
    this.setState({ loading: true });
    let eftAccountList = [...this.state.eftAccountList];
    let creditCardList = [...this.state.creditCardList];
    BusApiCall(
      "DELETE",
      `${constants.busV4Url}/customers/${this.props.partyId}/paymentMethods/${method.paymentMethodId}`,
    )
      .then((res) => {
        if (res.data.responseMessage === "success") {
          if (paymentType === "CREDIT_CARD") {
            creditCardList.splice(index, 1);
            this.setState({ loading: false, creditCardList: creditCardList });
            this.props.setErrorMessage(
              this.props.t("PAYMENT_METHOD_DELETED_SUCCESSFULLY"),
              true,
            );
          } else if (paymentType === "EFT_ACCOUNT") {
            eftAccountList.splice(index, 1);
            this.setState({ loading: false, eftAccountList: eftAccountList });
            this.props.setErrorMessage(
              this.props.t("PAYMENT_METHOD_DELETED_SUCCESSFULLY"),
              true,
            );
          }
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  editPaymentMethodDialogBox = (paymentMethod, method, index) => {
    this.setState({
      paymentMethodType: paymentMethod,
      editPaymentMethodDialog: true,

      //payment method billing details
      attention: method.attention,
      street1: method.street1,
      street2: method.street2,
      city: method.city,
      state: method.state,
      zip: method.zip,
      country: method.country,
      phone: method.phone,
    });
    if (paymentMethod === "CREDIT_CARD") {
      this.setState(
        {
          cardType: method.cardType,
          isPrimary: method.isPrimary,
          cardNumber: method.cardNumber,
          expireYear: method.expireYear,
          expireMonth: method.expireMonth,
          lastNameOnCard: method.lastNameOnCard,
          firstNameOnCard: method.firstNameOnCard,
          expireDate: method.expireMonth + "/" + method.expireYear,
          nameOnCard: method.firstNameOnCard + " " + method.lastNameOnCard,
          paymentMethodId: method.paymentMethodId,
        },
        () => {},
      );
    } else if (paymentMethod === "EFT_ACCOUNT") {
      this.setState(
        {
          bankName: method.bankName,
          accountType: method.accountType,
          routingNumber: method.routingNumber,
          accountNumber: method.accountNumber,
          nameOnAccount: method.nameOnAccount,
          paymentMethodId: method.paymentMethodId,
          isPrimary: method.isPrimary,
        },
        () => {},
      );
    }
  };

  setCountryName = (country) => {
    var list = this.props.countriesList;
    var index = list.findIndex((a) => a.id === country);
    if (index > -1) {
      return list[index].name;
    } else {
      return country;
    }
  };

  //render
  render() {
    const { t } = this.props;
    const { classes: jssClasses } = this.props;
    return (
      <React.Fragment>
        <Box
          className="roundCorners"
          style={{
            border: "1px solid lightgrey",
            marginTop: "1rem",
            padding: "1.5rem",
          }}
        >
          <div>
            <div
              style={{
                marginBottom:
                  this.props.screen === "paymentMethod" ? "2rem" : 0,
              }}
            >
              <h3 style={{ marginTop: 0, marginBottom: 0, float: "left" }}>
                {t("CREDIT_CARDS")}
              </h3>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {this.props.screen != "checkout" &&
                  this.state.creditCardList &&
                  this.state.creditCardList.length > 0 && (
                    <>
                      {this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                        this.props.userPerms.includes("PARTYMGR_ADMIN") && (
                          <>
                            <span>
                              <Button
                                className={"buttonSecondary"}
                                style={{ marginRight: "10px" }}
                                onClick={() =>
                                  this.addPaymentMethodDialogBox("CREDIT_CARD")
                                }
                              >
                                {this.props.invoicePayment ? (
                                  <>{t("PAY_CREDIT_CARD")}</>
                                ) : (
                                  <>
                                    <span
                                      style={{
                                        marginRight: ".25rem",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {t("ADD_A_CREDIT_CARD")}
                                  </>
                                )}{" "}
                              </Button>
                            </span>
                          </>
                        )}
                    </>
                  )}
              </div>
            </div>
          </div>
          {this.props.screen === "checkout" && (
            <Grid container spacing={0}>
              <Grid
                item
                align="center"
                onClick={() => {
                  this.props.screen === "checkout" &&
                    this.props.chooseExistingCustomerDetail(
                      "invoice",
                      this.props.tabValue,
                    );
                }}
                style={{
                  cursor:
                    this.props.screen === "checkout" ? "pointer" : "initial",
                }}
                size={{
                  xs: 12,
                }}
              >
                <b>{t("INVOICE_ME")}</b>
              </Grid>
            </Grid>
          )}
          {(!this.state.creditCardList ||
            this.state.creditCardList.length == 0) &&
            this.props.screen != "checkout" && (
              <Grid container spacing={2} align="center">
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  {t("NO_PAYMENT_METHOD_ADDED")}
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  {this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                    this.props.userPerms.includes("PARTYMGR_ADMIN") && (
                      <>
                        <span>
                          <Button
                            className={"buttonSecondary"}
                            style={{ marginRight: "10px" }}
                            onClick={() =>
                              this.addPaymentMethodDialogBox("CREDIT_CARD")
                            }
                          >
                            {this.props.invoicePayment ? (
                              <>{t("PAY_CREDIT_CARD")}</>
                            ) : (
                              <>
                                <span
                                  style={{
                                    marginRight: ".25rem",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <svg
                                    width="14"
                                    height="14"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                                {t("ADD_A_CREDIT_CARD")}
                              </>
                            )}{" "}
                          </Button>
                        </span>
                      </>
                    )}
                </Grid>
              </Grid>
            )}
          {this.state.creditCardList.map(
            (method, index) =>
              this.state.cardPaymentMethodOption && (
                <React.Fragment key={index}>
                  <Box
                    className="roundCorners"
                    style={{
                      border: "1px solid lightgrey",
                      marginTop: "1rem",
                      cursor:
                        this.props.screen === "checkout" ||
                        this.props.screen === "invoicePayment"
                          ? "pointer"
                          : "initial",
                    }}
                    onClick={() => {
                      (this.props.screen === "checkout" ||
                        this.props.screen === "invoicePayment") &&
                        this.props.chooseExistingCustomerDetail(
                          method,
                          this.props.tabValue,
                        );
                    }}
                  >
                    <Grid container style={{ padding: "1rem" }}>
                      <Grid
                        item
                        size={{
                          xs: 10,
                          md: 1,
                        }}
                      >
                        {this.props.screen != "checkout" &&
                          this.props.screen != "invoicePayment" && (
                            <Tooltip title={t("MAKE_DEFAULT")}>
                              <div className={classes.round}>
                                <input
                                  type="checkbox"
                                  readOnly
                                  checked={method.primary}
                                />
                                <label
                                  htmlFor="checkbox"
                                  onClick={(e) =>
                                    this.setMethodAsPrimary(
                                      e,
                                      index,
                                      "CREDIT_CARD",
                                    )
                                  }
                                ></label>
                              </div>
                            </Tooltip>
                          )}
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 6,
                        }}
                      >
                        {method.cardType === "CCT_VISA" ? (
                          <>
                            <CardPaymentIcon
                              id="visa"
                              className={classes.paymentIcon}
                            />
                          </>
                        ) : method.cardType === "CCT_MASTERCARD" ? (
                          <>
                            <CardPaymentIcon
                              id="mastercard"
                              className={classes.paymentIcon}
                            />
                          </>
                        ) : (
                          method.cardType === "CCT_AMERICANEXPRESS" && (
                            <>
                              <CardPaymentIcon
                                id="amex"
                                className={classes.paymentIcon}
                              />
                            </>
                          )
                        )}
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div>
                            <span>{t(method.cardType)} </span>
                            <span className={"separator-ellipse"}></span>
                            <span style={{ marginTop: "6px" }}>
                              {t("ENDING_IN")}{" "}
                              {method.cardNumber.slice(
                                method.cardNumber.length - 4,
                              )}{" "}
                            </span>
                          </div>

                          <div style={{ color: "#717784" }}>
                            <span>{t("EXPIRES")}: </span>
                            {method.expireDate}
                          </div>
                        </div>
                      </Grid>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 2,
                        }}
                      >
                        <span>
                          {method.primary && (
                            <Chip
                              size="normal"
                              className={"blueChip"}
                              style={{ padding: "0.6rem" }}
                              label={t("DEFAULT_PAYMENT_METHOD")}
                            />
                          )}
                        </span>
                      </Grid>
                      <Grid
                        item
                        style={{
                          justifyContent: "flex-end",
                          display: "flex",
                          gap: ".25rem",
                        }}
                        size={{
                          xs: 12,
                          md: 3,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "1rem",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: ".25rem",
                            }}
                          >
                            {this.props.loggedInUserType !==
                              "ECOMMERCE_CUSTOMER" && (
                              <Button
                                className="buttonSecondary"
                                onClick={() =>
                                  this.editPaymentMethodDialogBox(
                                    "CREDIT_CARD",
                                    method,
                                    index,
                                  )
                                }
                              >
                                <span>
                                  <svg
                                    width="16"
                                    height="15"
                                    viewBox="0 0 13 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span>
                              </Button>
                            )}
                            {this.props.screen != "checkout" &&
                              this.props.screen != "invoicePayment" &&
                              !method.primary && (
                                <Button
                                  className={"buttonSecondary"}
                                  onClick={() => {
                                    this.removePaymentMethod(
                                      method,
                                      index,
                                      "CREDIT_CARD",
                                    );
                                  }}
                                >
                                  <span>
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 12 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M4 1.5C4 1.22386 4.22386 1 4.5 1H7.5C7.77614 1 8 1.22386 8 1.5C8 1.77614 7.77614 2 7.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM2.49612 2.5H1.5C1.22386 2.5 1 2.72386 1 3C1 3.27614 1.22386 3.5 1.5 3.5H2.03222L2.35307 8.31272C2.37825 8.69044 2.39908 9.00302 2.43644 9.25744C2.47533 9.52234 2.53702 9.76441 2.66555 9.99C2.86562 10.3412 3.16739 10.6235 3.53111 10.7998C3.76476 10.913 4.0104 10.9585 4.2773 10.9797C4.53364 11 4.84691 11 5.22547 11H6.77453C7.15309 11 7.46636 11 7.7227 10.9797C7.9896 10.9585 8.23524 10.913 8.46889 10.7998C8.83261 10.6235 9.13439 10.3412 9.33446 9.99C9.46298 9.76441 9.52467 9.52234 9.56356 9.25744C9.60092 9.003 9.62176 8.6904 9.64693 8.31265L9.96778 3.5H10.5C10.7761 3.5 11 3.27614 11 3C11 2.72386 10.7761 2.5 10.5 2.5H9.50388C9.50096 2.49997 9.49804 2.49997 9.49513 2.5H2.50487C2.50196 2.49997 2.49904 2.49997 2.49612 2.5ZM8.96556 3.5H3.03444L3.34954 8.22639C3.37637 8.62889 3.39492 8.90168 3.42583 9.11217C3.45585 9.31663 3.49252 9.42143 3.53444 9.495C3.63447 9.6706 3.78536 9.81176 3.96722 9.89989C4.04342 9.93682 4.15043 9.96645 4.35643 9.9828C4.56851 9.99963 4.84193 10 5.24533 10H6.75467C7.15807 10 7.43149 9.99963 7.64357 9.9828C7.84957 9.96645 7.95658 9.93682 8.03278 9.89989C8.21464 9.81176 8.36553 9.6706 8.46556 9.495C8.50748 9.42143 8.54415 9.31663 8.57417 9.11217C8.60508 8.90168 8.62363 8.62889 8.65046 8.22639L8.96556 3.5ZM5 4.75C5.27614 4.75 5.5 4.97386 5.5 5.25V7.75C5.5 8.02614 5.27614 8.25 5 8.25C4.72386 8.25 4.5 8.02614 4.5 7.75V5.25C4.5 4.97386 4.72386 4.75 5 4.75ZM7 4.75C7.27614 4.75 7.5 4.97386 7.5 5.25V7.75C7.5 8.02614 7.27614 8.25 7 8.25C6.72386 8.25 6.5 8.02614 6.5 7.75V5.25C6.5 4.97386 6.72386 4.75 7 4.75Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                </Button>
                              )}
                          </div>
                          {this.props.screen != "checkout" &&
                            this.props.screen != "invoicePayment" && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  this.setOpen(
                                    !method.openCardDetails,
                                    "CREDIT_CARD",
                                    index,
                                  )
                                }
                              >
                                <span style={{ marginRight: "0.25rem" }}>
                                  {method.openCardDetails
                                    ? "Collapse"
                                    : "Expand"}
                                </span>
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                >
                                  {method.openCardDetails ? (
                                    <KeyboardArrowUpIcon />
                                  ) : (
                                    <KeyboardArrowDownIcon />
                                  )}
                                </IconButton>
                              </div>
                            )}
                        </div>
                      </Grid>
                    </Grid>
                    {method.openCardDetails && (
                      <>
                        <Collapse
                          in={method.openCardDetails}
                          timeout="auto"
                          unmountOnExit
                          style={{ padding: "1rem" }}
                        >
                          <Divider variant="middle" />
                          <Grid
                            style={{ marginTop: "1rem", marginLeft: "1rem" }}
                            container
                            spacing={2}
                            onClick={() => {
                              this.props.screen === "checkout" &&
                                this.props.chooseExistingCustomerDetail(
                                  method,
                                  this.props.tabValue,
                                );
                            }}
                          >
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 4,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: ".5rem",
                                }}
                              >
                                <div style={{ color: "#717784" }}>
                                  {t("NAME_ON_CARD")}
                                </div>
                                <div>
                                  {method.firstNameOnCard}{" "}
                                  {method.lastNameOnCard}
                                </div>
                              </div>
                            </Grid>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 8,
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: ".5rem",
                                }}
                              >
                                <div style={{ color: "#717784" }}>
                                  {t("BILLING_ADDRESS")}
                                </div>
                                <div>
                                  {method.attention && (
                                    <>
                                      <span style={{ marginRight: ".5rem" }}>
                                        <svg
                                          width="17"
                                          height="16"
                                          viewBox="0 0 17 16"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M8.5 2.66674C7.21134 2.66674 6.16667 3.71141 6.16667 5.00007C6.16667 6.28874 7.21134 7.3334 8.5 7.3334C9.78866 7.3334 10.8333 6.28874 10.8333 5.00007C10.8333 3.71141 9.78866 2.66674 8.5 2.66674ZM4.83333 5.00007C4.83333 2.97503 6.47496 1.3334 8.5 1.3334C10.525 1.3334 12.1667 2.97503 12.1667 5.00007C12.1667 7.02512 10.525 8.66674 8.5 8.66674C6.47496 8.66674 4.83333 7.02512 4.83333 5.00007ZM6.71751 9.66671C6.75555 9.66672 6.79416 9.66673 6.83334 9.66673H10.1667C10.2058 9.66673 10.2444 9.66672 10.2825 9.66671C11.1007 9.6664 11.6593 9.6662 12.1343 9.81027C13.1996 10.1334 14.0333 10.9671 14.3565 12.0324C14.5005 12.5074 14.5003 13.0661 14.5 13.8842C14.5 13.9223 14.5 13.9609 14.5 14.0001C14.5 14.3683 14.2015 14.6667 13.8333 14.6667C13.4651 14.6667 13.1667 14.3683 13.1667 14.0001C13.1667 13.0212 13.1594 12.6795 13.0805 12.4195C12.8866 11.7803 12.3864 11.2801 11.7472 11.0862C11.4872 11.0073 11.1455 11.0001 10.1667 11.0001H6.83334C5.85446 11.0001 5.51281 11.0073 5.25276 11.0862C4.61356 11.2801 4.11335 11.7803 3.91945 12.4195C3.84057 12.6795 3.83333 13.0212 3.83333 14.0001C3.83333 14.3683 3.53486 14.6667 3.16667 14.6667C2.79848 14.6667 2.5 14.3683 2.5 14.0001C2.5 13.9609 2.49999 13.9223 2.49997 13.8842C2.49967 13.0661 2.49946 12.5074 2.64353 12.0324C2.9667 10.9671 3.80038 10.1334 4.86572 9.81027C5.34065 9.6662 5.89933 9.6664 6.71751 9.66671Z"
                                            fill="#717784"
                                          />
                                        </svg>
                                      </span>
                                      <b>{method.attention}</b> <br />
                                    </>
                                  )}
                                </div>
                                <div style={{ display: "flex" }}>
                                  {(method.street1 ||
                                    method.street2 ||
                                    method.city ||
                                    method.state ||
                                    method.zip ||
                                    method.country) && (
                                    <>
                                      <div style={{ marginRight: ".5rem" }}>
                                        <svg
                                          width="17"
                                          height="16"
                                          viewBox="0 0 17 16"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M8.5 2.54546C6.15697 2.54546 4.25758 4.44486 4.25758 6.78789C4.25758 7.93462 4.77465 9.01701 5.64684 10.1495C6.38328 11.1058 7.3259 12.0408 8.33774 13.0444C8.39164 13.0979 8.44573 13.1515 8.5 13.2054C8.55427 13.1515 8.60836 13.0979 8.66226 13.0444C9.6741 12.0408 10.6167 11.1058 11.3532 10.1495C12.2254 9.01701 12.7424 7.93462 12.7424 6.78789C12.7424 4.44486 10.843 2.54546 8.5 2.54546ZM3.04545 6.78789C3.04545 3.77543 5.48754 1.33334 8.5 1.33334C11.5125 1.33334 13.9545 3.77543 13.9545 6.78789C13.9545 8.31891 13.2595 9.66076 12.3135 10.8891C11.523 11.9156 10.5112 12.9186 9.5005 13.9205C9.30931 14.1101 9.11816 14.2996 8.92855 14.4892C8.69187 14.7258 8.30813 14.7258 8.07145 14.4892C7.88184 14.2996 7.69069 14.1101 7.4995 13.9205C6.48877 12.9186 5.477 11.9156 4.6865 10.8891C3.7405 9.66076 3.04545 8.31891 3.04545 6.78789ZM8.5 5.57577C7.83056 5.57577 7.28788 6.11845 7.28788 6.78789C7.28788 7.45732 7.83056 8.00001 8.5 8.00001C9.16944 8.00001 9.71212 7.45732 9.71212 6.78789C9.71212 6.11845 9.16944 5.57577 8.5 5.57577ZM6.07576 6.78789C6.07576 5.44902 7.16113 4.36365 8.5 4.36365C9.83887 4.36365 10.9242 5.44902 10.9242 6.78789C10.9242 8.12676 9.83887 9.21213 8.5 9.21213C7.16113 9.21213 6.07576 8.12676 6.07576 6.78789Z"
                                            fill="#717784"
                                          />
                                        </svg>
                                      </div>
                                      <div>
                                        <>
                                          {method.street1 && (
                                            <>{method.street1}, </>
                                          )}
                                          {method.street2 && (
                                            <>{method.street2}, </>
                                          )}
                                          {method.city && method.city},{" "}
                                          {method.state && method.state}{" "}
                                          {method.zip && method.zip} <br />
                                          {method.country &&
                                            this.setCountryName(method.country)}
                                        </>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </Collapse>
                      </>
                    )}
                  </Box>
                </React.Fragment>
              ),
          )}
        </Box>
        {/* Add Payment details */}
        <Box
          className="roundCorners"
          style={{
            border: "1px solid lightgrey",
            marginTop: "1rem",
            padding: "1.5rem",
          }}
        >
          <div>
            <div
              style={{
                marginBottom:
                  this.props.screen === "paymentMethod" ? "2rem" : 0,
              }}
            >
              <h3 style={{ marginTop: 0, marginBottom: 0, float: "left" }}>
                {t("BANK_ACCOUNT")}
              </h3>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {this.props.screen != "checkout" &&
                  this.state.eftAccountList.length > 0 && (
                    <>
                      {this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                        this.props.userPerms.includes("PARTYMGR_ADMIN") && (
                          <>
                            <span>
                              <Button
                                className={"buttonSecondary"}
                                onClick={() =>
                                  this.addPaymentMethodDialogBox("EFT_ACCOUNT")
                                }
                              >
                                {this.props.invoicePayment ? (
                                  <>{t("PAY_BANK_ACCOUNT")}</>
                                ) : (
                                  <>
                                    <span
                                      style={{
                                        marginRight: ".25rem",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 12 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {t("ADD_A_BANK_ACCOUNT")}
                                  </>
                                )}
                              </Button>
                            </span>
                          </>
                        )}
                    </>
                  )}
              </div>
            </div>
          </div>
          {this.state.eftAccountList.length === 0 && (
            <Grid container spacing={2} align="center">
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                {t("NO_PAYMENT_METHOD_ADDED")}
              </Grid>
              <Grid
                item
                size={{
                  xs: 12,
                }}
              >
                {this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                  this.props.userPerms.includes("PARTYMGR_ADMIN") && (
                    <>
                      <span>
                        <Button
                          className={"buttonSecondary"}
                          onClick={() =>
                            this.addPaymentMethodDialogBox("EFT_ACCOUNT")
                          }
                        >
                          {this.props.invoicePayment ? (
                            <>{t("PAY_BANK_ACCOUNT")}</>
                          ) : (
                            <>
                              <span
                                style={{
                                  marginRight: ".25rem",
                                  verticalAlign: "middle",
                                }}
                              >
                                <svg
                                  width="14"
                                  height="14"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {t("ADD_A_BANK_ACCOUNT")}
                            </>
                          )}
                        </Button>
                      </span>
                    </>
                  )}
              </Grid>
            </Grid>
          )}
          {this.state.eftAccountList.length > 0 &&
            this.state.eftAccountList.map(
              (method, index) =>
                this.state.bankPaymentMethodOption && (
                  <>
                    <React.Fragment key={index}>
                      <Box
                        className="roundCorners"
                        style={{
                          border: "1px solid lightgrey",
                          marginTop: "1rem",
                          cursor:
                            this.props.screen === "checkout" ||
                            this.props.screen === "invoicePayment"
                              ? "pointer"
                              : "initial",
                        }}
                        onClick={() => {
                          (this.props.screen === "checkout" ||
                            this.props.screen === "invoicePayment") &&
                            this.props.chooseExistingCustomerDetail(
                              method,
                              this.props.tabValue,
                            );
                        }}
                      >
                        <Grid container style={{ padding: "1rem" }}>
                          <Grid
                            item
                            size={{
                              xs: 10,
                              md: 1,
                            }}
                          >
                            {this.props.screen != "checkout" &&
                              this.props.screen != "invoicePayment" && (
                                <Tooltip title={t("MAKE_DEFAULT")}>
                                  <div className={classes.round}>
                                    <input
                                      type="checkbox"
                                      readOnly
                                      checked={method.primary}
                                    />
                                    <label
                                      htmlFor="checkbox"
                                      onClick={(e) =>
                                        this.setMethodAsPrimary(
                                          e,
                                          index,
                                          "EFT_ACCOUNT",
                                        )
                                      }
                                    ></label>
                                  </div>
                                </Tooltip>
                              )}
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 6,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div>
                                <span>{t(method.bankName)} </span>
                                <span className={"separator-ellipse"}></span>
                                <span style={{ marginTop: "6px" }}>
                                  {t("ENDING_IN")}{" "}
                                  {method.accountNumber.slice(
                                    method.accountNumber.length - 4,
                                  )}{" "}
                                </span>
                              </div>
                              <div style={{ color: "#717784" }}>
                                <span>{t("ACCOUNT_TYPE")}: </span>
                                {t("CHECKING")}
                              </div>
                            </div>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 2,
                            }}
                          >
                            <span>
                              {method.primary && (
                                <Chip
                                  size="normal"
                                  className={"blueChip"}
                                  style={{ padding: "0.6rem" }}
                                  label={t("DEFAULT_PAYMENT_METHOD")}
                                />
                              )}
                            </span>
                          </Grid>
                          <Grid
                            item
                            style={{
                              justifyContent: "flex-end",
                              display: "flex",
                              gap: ".25rem",
                            }}
                            size={{
                              xs: 12,
                              md: 3,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "1rem",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  gap: ".25rem",
                                }}
                              >
                                {this.props.loggedInUserType !==
                                  "ECOMMERCE_CUSTOMER" && (
                                  <Button
                                    className="buttonSecondary"
                                    onClick={() =>
                                      this.editPaymentMethodDialogBox(
                                        "EFT_ACCOUNT",
                                        method,
                                        index,
                                      )
                                    }
                                  >
                                    <span>
                                      <svg
                                        width="16"
                                        height="15"
                                        viewBox="0 0 13 12"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M9.45509 1.93945C9.30639 1.93945 9.16379 1.99852 9.05864 2.10367L2.90657 8.25574L2.64227 9.31293L3.69946 9.04863L9.85154 2.89656C9.9036 2.8445 9.94489 2.78269 9.97307 2.71467C10.0012 2.64665 10.0157 2.57374 10.0157 2.50011C10.0157 2.42649 10.0012 2.35358 9.97307 2.28556C9.94489 2.21754 9.9036 2.15573 9.85154 2.10367C9.79947 2.0516 9.73767 2.01031 9.66964 1.98213C9.60162 1.95395 9.52872 1.93945 9.45509 1.93945ZM8.35154 1.39656C8.64422 1.10388 9.04118 0.939453 9.45509 0.939453C9.66004 0.939453 9.86298 0.979821 10.0523 1.05825C10.2417 1.13668 10.4137 1.25164 10.5586 1.39656C10.7036 1.54148 10.8185 1.71353 10.897 1.90287C10.9754 2.09222 11.0157 2.29516 11.0157 2.50011C11.0157 2.70506 10.9754 2.908 10.897 3.09735C10.8185 3.2867 10.7036 3.45875 10.5586 3.60367L4.30864 9.85367C4.24456 9.91775 4.16427 9.96321 4.07636 9.98518L2.07636 10.4852C1.90597 10.5278 1.72573 10.4779 1.60154 10.3537C1.47735 10.2295 1.42742 10.0492 1.47002 9.87885L1.97002 7.87885C1.992 7.79093 2.03746 7.71064 2.10154 7.64656L8.35154 1.39656ZM5.95509 10.0001C5.95509 9.72397 6.17895 9.50011 6.45509 9.50011H10.9551C11.2312 9.50011 11.4551 9.72397 11.4551 10.0001C11.4551 10.2763 11.2312 10.5001 10.9551 10.5001H6.45509C6.17895 10.5001 5.95509 10.2763 5.95509 10.0001Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                  </Button>
                                )}
                                {this.props.screen != "checkout" &&
                                  this.props.screen != "invoicePayment" &&
                                  !method.primary && (
                                    <Button
                                      className={"buttonSecondary"}
                                      onClick={() => {
                                        this.removePaymentMethod(
                                          method,
                                          index,
                                          "EFT_ACCOUNT",
                                        );
                                      }}
                                    >
                                      <span>
                                        <svg
                                          width="16"
                                          height="16"
                                          viewBox="0 0 12 12"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M4 1.5C4 1.22386 4.22386 1 4.5 1H7.5C7.77614 1 8 1.22386 8 1.5C8 1.77614 7.77614 2 7.5 2H4.5C4.22386 2 4 1.77614 4 1.5ZM2.49612 2.5H1.5C1.22386 2.5 1 2.72386 1 3C1 3.27614 1.22386 3.5 1.5 3.5H2.03222L2.35307 8.31272C2.37825 8.69044 2.39908 9.00302 2.43644 9.25744C2.47533 9.52234 2.53702 9.76441 2.66555 9.99C2.86562 10.3412 3.16739 10.6235 3.53111 10.7998C3.76476 10.913 4.0104 10.9585 4.2773 10.9797C4.53364 11 4.84691 11 5.22547 11H6.77453C7.15309 11 7.46636 11 7.7227 10.9797C7.9896 10.9585 8.23524 10.913 8.46889 10.7998C8.83261 10.6235 9.13439 10.3412 9.33446 9.99C9.46298 9.76441 9.52467 9.52234 9.56356 9.25744C9.60092 9.003 9.62176 8.6904 9.64693 8.31265L9.96778 3.5H10.5C10.7761 3.5 11 3.27614 11 3C11 2.72386 10.7761 2.5 10.5 2.5H9.50388C9.50096 2.49997 9.49804 2.49997 9.49513 2.5H2.50487C2.50196 2.49997 2.49904 2.49997 2.49612 2.5ZM8.96556 3.5H3.03444L3.34954 8.22639C3.37637 8.62889 3.39492 8.90168 3.42583 9.11217C3.45585 9.31663 3.49252 9.42143 3.53444 9.495C3.63447 9.6706 3.78536 9.81176 3.96722 9.89989C4.04342 9.93682 4.15043 9.96645 4.35643 9.9828C4.56851 9.99963 4.84193 10 5.24533 10H6.75467C7.15807 10 7.43149 9.99963 7.64357 9.9828C7.84957 9.96645 7.95658 9.93682 8.03278 9.89989C8.21464 9.81176 8.36553 9.6706 8.46556 9.495C8.50748 9.42143 8.54415 9.31663 8.57417 9.11217C8.60508 8.90168 8.62363 8.62889 8.65046 8.22639L8.96556 3.5ZM5 4.75C5.27614 4.75 5.5 4.97386 5.5 5.25V7.75C5.5 8.02614 5.27614 8.25 5 8.25C4.72386 8.25 4.5 8.02614 4.5 7.75V5.25C4.5 4.97386 4.72386 4.75 5 4.75ZM7 4.75C7.27614 4.75 7.5 4.97386 7.5 5.25V7.75C7.5 8.02614 7.27614 8.25 7 8.25C6.72386 8.25 6.5 8.02614 6.5 7.75V5.25C6.5 4.97386 6.72386 4.75 7 4.75Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                    </Button>
                                  )}
                              </div>
                              {this.props.screen != "checkout" &&
                                this.props.screen != "invoicePayment" && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "flex-end",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      this.setOpen(
                                        !method.openBankDetails,
                                        "EFT_ACCOUNT",
                                        index,
                                      )
                                    }
                                  >
                                    <span style={{ marginRight: "0.25rem" }}>
                                      {method.openCardDetails
                                        ? "Collapse"
                                        : "Expand"}
                                    </span>
                                    <IconButton
                                      aria-label="expand row"
                                      size="small"
                                    >
                                      {method.openBankDetails ? (
                                        <KeyboardArrowUpIcon />
                                      ) : (
                                        <KeyboardArrowDownIcon />
                                      )}
                                    </IconButton>
                                  </div>
                                )}
                            </div>
                          </Grid>
                        </Grid>
                        {method.openBankDetails && (
                          <>
                            <Collapse
                              in={method.openBankDetails}
                              timeout="auto"
                              unmountOnExit
                              style={{ padding: "1rem" }}
                            >
                              <Divider variant="middle" />
                              <Grid
                                style={{
                                  marginTop: "1rem",
                                  marginLeft: "1rem",
                                }}
                                container
                                spacing={2}
                                onClick={() => {
                                  this.props.screen === "checkout" &&
                                    this.props.chooseExistingCustomerDetail(
                                      method,
                                      this.props.tabValue,
                                    );
                                }}
                              >
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 4,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: ".5rem",
                                    }}
                                  >
                                    <div style={{ color: "#717784" }}>
                                      {t("NAME_ON_ACCOUNT")}
                                    </div>
                                    <div>{method.nameOnAccount}</div>
                                  </div>
                                </Grid>
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 8,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: ".5rem",
                                    }}
                                  >
                                    <div style={{ color: "#717784" }}>
                                      {t("BILLING_ADDRESS")}
                                    </div>
                                    <div>
                                      {method.attention && (
                                        <>
                                          <span
                                            style={{ marginRight: ".5rem" }}
                                          >
                                            <svg
                                              width="17"
                                              height="16"
                                              viewBox="0 0 17 16"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M8.5 2.66674C7.21134 2.66674 6.16667 3.71141 6.16667 5.00007C6.16667 6.28874 7.21134 7.3334 8.5 7.3334C9.78866 7.3334 10.8333 6.28874 10.8333 5.00007C10.8333 3.71141 9.78866 2.66674 8.5 2.66674ZM4.83333 5.00007C4.83333 2.97503 6.47496 1.3334 8.5 1.3334C10.525 1.3334 12.1667 2.97503 12.1667 5.00007C12.1667 7.02512 10.525 8.66674 8.5 8.66674C6.47496 8.66674 4.83333 7.02512 4.83333 5.00007ZM6.71751 9.66671C6.75555 9.66672 6.79416 9.66673 6.83334 9.66673H10.1667C10.2058 9.66673 10.2444 9.66672 10.2825 9.66671C11.1007 9.6664 11.6593 9.6662 12.1343 9.81027C13.1996 10.1334 14.0333 10.9671 14.3565 12.0324C14.5005 12.5074 14.5003 13.0661 14.5 13.8842C14.5 13.9223 14.5 13.9609 14.5 14.0001C14.5 14.3683 14.2015 14.6667 13.8333 14.6667C13.4651 14.6667 13.1667 14.3683 13.1667 14.0001C13.1667 13.0212 13.1594 12.6795 13.0805 12.4195C12.8866 11.7803 12.3864 11.2801 11.7472 11.0862C11.4872 11.0073 11.1455 11.0001 10.1667 11.0001H6.83334C5.85446 11.0001 5.51281 11.0073 5.25276 11.0862C4.61356 11.2801 4.11335 11.7803 3.91945 12.4195C3.84057 12.6795 3.83333 13.0212 3.83333 14.0001C3.83333 14.3683 3.53486 14.6667 3.16667 14.6667C2.79848 14.6667 2.5 14.3683 2.5 14.0001C2.5 13.9609 2.49999 13.9223 2.49997 13.8842C2.49967 13.0661 2.49946 12.5074 2.64353 12.0324C2.9667 10.9671 3.80038 10.1334 4.86572 9.81027C5.34065 9.6662 5.89933 9.6664 6.71751 9.66671Z"
                                                fill="#717784"
                                              />
                                            </svg>
                                          </span>
                                          <b>{method.attention}</b> <br />
                                        </>
                                      )}
                                    </div>
                                    <div style={{ display: "flex" }}>
                                      {(method.street1 ||
                                        method.street2 ||
                                        method.city ||
                                        method.state ||
                                        method.zip ||
                                        method.country) && (
                                        <>
                                          <div style={{ marginRight: ".5rem" }}>
                                            <svg
                                              width="17"
                                              height="16"
                                              viewBox="0 0 17 16"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M8.5 2.54546C6.15697 2.54546 4.25758 4.44486 4.25758 6.78789C4.25758 7.93462 4.77465 9.01701 5.64684 10.1495C6.38328 11.1058 7.3259 12.0408 8.33774 13.0444C8.39164 13.0979 8.44573 13.1515 8.5 13.2054C8.55427 13.1515 8.60836 13.0979 8.66226 13.0444C9.6741 12.0408 10.6167 11.1058 11.3532 10.1495C12.2254 9.01701 12.7424 7.93462 12.7424 6.78789C12.7424 4.44486 10.843 2.54546 8.5 2.54546ZM3.04545 6.78789C3.04545 3.77543 5.48754 1.33334 8.5 1.33334C11.5125 1.33334 13.9545 3.77543 13.9545 6.78789C13.9545 8.31891 13.2595 9.66076 12.3135 10.8891C11.523 11.9156 10.5112 12.9186 9.5005 13.9205C9.30931 14.1101 9.11816 14.2996 8.92855 14.4892C8.69187 14.7258 8.30813 14.7258 8.07145 14.4892C7.88184 14.2996 7.69069 14.1101 7.4995 13.9205C6.48877 12.9186 5.477 11.9156 4.6865 10.8891C3.7405 9.66076 3.04545 8.31891 3.04545 6.78789ZM8.5 5.57577C7.83056 5.57577 7.28788 6.11845 7.28788 6.78789C7.28788 7.45732 7.83056 8.00001 8.5 8.00001C9.16944 8.00001 9.71212 7.45732 9.71212 6.78789C9.71212 6.11845 9.16944 5.57577 8.5 5.57577ZM6.07576 6.78789C6.07576 5.44902 7.16113 4.36365 8.5 4.36365C9.83887 4.36365 10.9242 5.44902 10.9242 6.78789C10.9242 8.12676 9.83887 9.21213 8.5 9.21213C7.16113 9.21213 6.07576 8.12676 6.07576 6.78789Z"
                                                fill="#717784"
                                              />
                                            </svg>
                                          </div>
                                          <div>
                                            <>
                                              {method.street1 && (
                                                <>{method.street1}, </>
                                              )}
                                              {method.street2 && (
                                                <>{method.street2}, </>
                                              )}
                                              {method.city && method.city},{" "}
                                              {method.state && method.state}{" "}
                                              {method.zip && method.zip} <br />
                                              {method.country &&
                                                this.setCountryName(
                                                  method.country,
                                                )}
                                            </>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </Grid>
                              </Grid>
                            </Collapse>
                          </>
                        )}
                      </Box>
                    </React.Fragment>
                  </>
                ),
            )}
        </Box>
        {/* existing credit cards list ends*/}
        <Loader loading={this.state.loading} />
        {/* editPaymentMethodDialog Starts */}
        <Dialog
          fullWidth={true}
          maxWidth={"md"}
          PaperComponent={this.draggableDialogPaper}
          PaperProps={
            {
              // className: jssClasses.resizablePaper
            }
          }
          open={this.state.editPaymentMethodDialog}
          onClose={(event) => this.handleDialog(false)}
          aria-labelledby="draggableDialogPaper"
        >
          {/* <DialogTitle id="form-dialog-title" className={classes.paymentMethods}>{this.state.dialogTitle}</DialogTitle> */}
          <DialogTitle
            id="draggableDialogPaper"
            style={{ cursor: "move" }}
            className={classes.paymentMethods}
          >
            {this.state.paymentMethodType === "CREDIT_CARD" &&
              t("EDIT_CREDIT_CARD")}
            {this.state.paymentMethodType === "EFT_ACCOUNT" &&
              t("EDIT_ACCOUNT")}
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              {/* edit credit card start */}
              {this.state.paymentMethodType === "CREDIT_CARD" && (
                <>
                  <Grid
                    item
                    size={{
                      xs: 2,
                    }}
                  >
                    {" "}
                    <b>{t("PAYMENT_METHOD")}</b>{" "}
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 1,
                    }}
                  ></Grid>
                  <Grid
                    item
                    size={{
                      xs: 4,
                    }}
                  >
                    {" "}
                    <b>{t("NAME_ON_CARD")}</b>{" "}
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 1,
                    }}
                  ></Grid>
                  <Grid
                    item
                    size={{
                      xs: 4,
                    }}
                  >
                    {" "}
                    <b>{t("EXPIRATION_DATE")}</b>
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 2,
                    }}
                  >
                    {t("ENDING_IN")}{" "}
                    {this.state.cardNumber.slice(
                      this.state.cardNumber.length - 4,
                    )}
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 1,
                    }}
                  >
                    {" "}
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 2,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      name={"firstNameOnCard"}
                      placeholder={t("FIRST_NAME") + " *"}
                      value={this.state.firstNameOnCard}
                      onChange={(e) => {
                        this.updateChange(e, "CREDIT_CARD");
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 2,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      name={"lastNameOnCard"}
                      placeholder={t("LAST_NAME") + " *"}
                      value={this.state.lastNameOnCard}
                      onChange={(e) => {
                        this.updateChange(e, "CREDIT_CARD");
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 1,
                    }}
                  >
                    {" "}
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 2,
                    }}
                  >
                    <FormControl
                      variant={"outlined"}
                      size={"small"}
                    >
                      <InputLabel id="expireMonth-label">
                        {t("MONTH") + " *"}
                      </InputLabel>
                      <Select
                        native
                        labelId="expireMonth-label"
                        label={t("MONTH") + " *"}
                        value={this.state.expireMonth}
                        inputProps={{
                          name: "expireMonth",
                          id: "expireMonth",
                        }}
                        onChange={(e) => {
                          this.updateChange(e, "CREDIT_CARD");
                        }}
                      >
                        {this.state.months.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 2,
                    }}
                  >
                    <FormControl
                      variant={"outlined"}
                      size={"small"}
                    >
                      <InputLabel id="expireYear-label">
                        {" "}
                        {t("YEAR") + " *"}
                      </InputLabel>
                      <Select
                        native
                        labelId="expireYear-label"
                        label={t("YEAR") + " *"}
                        value={this.state.expireYear}
                        inputProps={{
                          name: "expireYear",
                          id: "expireYear",
                        }}
                        onChange={(e) => {
                          this.updateChange(e, "CREDIT_CARD");
                        }}
                      >
                        {this.state.years.map((opt) => (
                          <option key={opt} value={opt}>
                            {opt}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <b>{t("BILLING_ADDRESS")}</b>
                    <br />
                    {this.state.attention && (
                      <>
                        {this.state.attention}
                        <br />
                      </>
                    )}
                    {this.state.street1 && (
                      <>
                        {this.state.street1} <br />
                      </>
                    )}
                    {this.state.street2 && (
                      <>
                        {this.state.street2} <br />
                      </>
                    )}
                    <>
                      {this.state.city}, {this.state.state}, {this.state.zip}{" "}
                      <br />
                    </>
                    {this.state.country}
                  </Grid>
                </>
              )}
              {/* add credit card ends */}

              {/* add EFT bank account */}
              {this.state.paymentMethodType === "EFT_ACCOUNT" && (
                <>
                  <Grid
                    item
                    size={{
                      xs: 4,
                    }}
                  >
                    {" "}
                    <b>{t("PAYMENT_METHOD")}</b>{" "}
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 2,
                    }}
                  ></Grid>
                  <Grid
                    item
                    size={{
                      xs: 4,
                    }}
                  >
                    {" "}
                    <b>{t("NAME_ON_ACCOUNT")}</b>{" "}
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 2,
                    }}
                  ></Grid>

                  <Grid
                    item
                    size={{
                      xs: 4,
                    }}
                  >
                    {this.state.bankName} {t("ENDING_IN")}{" "}
                    {this.state.accountNumber.slice(
                      this.state.accountNumber.length - 4,
                    )}
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 2,
                    }}
                  >
                    {" "}
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 4,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      name={"nameOnAccount"}
                      placeholder={t("NAME_ON_ACCOUNT")}
                      value={this.state.nameOnAccount}
                      onChange={(e) => {
                        this.updateChange(e, "EFT_ACCOUNT");
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 2,
                    }}
                  >
                    {" "}
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <b>{t("BILLING_ADDRESS")}</b>
                    <br />
                    {this.state.attention && (
                      <>
                        {this.state.attention}
                        <br />
                      </>
                    )}
                    {this.state.street1 && (
                      <>
                        {this.state.street1} <br />
                      </>
                    )}
                    {this.state.street2 && (
                      <>
                        {this.state.street2} <br />
                      </>
                    )}
                    <>
                      {this.state.city}, {this.state.state}, {this.state.zip}{" "}
                      <br />
                    </>
                    {this.state.country}
                  </Grid>
                </>
              )}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(event) => this.handleDialog(false)}
              color="primary"
            >
              {t("CANCEL")}
            </Button>
            <Button
              onClick={(event) =>
                this.updateCustomerPaymentPayload(this.state.paymentMethodType)
              }
              color="primary"
            >
              {t("SAVE")}
            </Button>
          </DialogActions>
        </Dialog>
        {/* add a payment method */}
        {this.state.addPaymentMethodDialog && (
          <PaymentMethodDialog
            years={this.state.years}
            months={this.state.months}
            close={this.createPaymentMethodPayload}
            dialogTitle={t("ADD_DETAILS")}
            //cardLogoId={this.state.cardLogoId}
            paymentMethodType={this.state.paymentMethodType}
            open={this.state.addPaymentMethodDialog}
            billingAddressList={this.state.billingAddressList}
            dataError={this.state.dataError}
            isFirstPaymentMethod={this.state.isFirstPaymentMethod}
            screen={this.props.screen}
            invoicePayment={this.props.invoicePayment}
          />
        )}
      </React.Fragment>
    );
  }
}

const styles = {
  resizablePaper: {
    resize: "both",
    overflow: "auto",
    minWidth: 640,
    minHeight: 200,
    maxWidth: "90vw",
    maxHeight: "90vh",
    width: "60vw",
  },
};

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    loggedInUserType: state.auth.userLoginType,
    countriesList: state.global.countriesList,
    defaultCountry: state.auth.defaultCountry,
    userPerms: state.auth.userPerms,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(PaymentDetails));
